var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-notfound"},[_c('div-container',[_c('div',{staticClass:"hero is-primary"},[_c('div',{staticClass:"hero-body content has-text-centered"},[_c('div',{staticStyle:{"padding":"30px"}},[_c('h1',{staticClass:"title"},[_vm._v(" Uh oh ")]),_c('h2',{staticClass:"subtitle"},[_vm._v(" 404 Page Not Found ")])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }